<ng-template #optionCardContent>
  <div class="position-relative h-100">
    <div class="card omgui-option-card d-flex h-100 justify-content-start p-4">
      <div>
        <p class="optionCardTitle title m-0" data-cy="omgui-option-card-title-content">
          <ng-container *ngIf="title">
            {{ title }}
          </ng-container>
        </p>

        <div
          *ngIf="description"
          class="description text-emphasis-medium mt-3"
          data-cy="omgui-option-card-description-content"
          [innerHTML]="description"
        >
          <ng-container>{{ description }}</ng-container>
        </div>
        <div class="disclaimer text-emphasis-medium mt-3" data-cy="omgui-option-card-disclaimer-content">
          <ng-container *ngIf="disclaimer">
            <img class="icon ms-0" src="{{ disclaimerIconUrl }}" aria-hidden="true" />
            {{ disclaimer }}
          </ng-container>
        </div>
        <div *ngIf="tags && tagsTitle" class="text-emphasis-medium mt-3">
          <span
            >{{ tagsTitle }}
            <span class="tags px-2 py-1 m-1 text-nowrap" *ngFor="let tagsItem of tags">{{ tagsItem }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<a
  class="text-decoration-none omgui-option-card-link-wrapper h-100"
  (click)="onClick($event)"
  [routerLink]="route || null"
  [omTrackLink]="trackLink"
  [attr.data-cy]="dataCy"
>
  <ng-container *ngTemplateOutlet="optionCardContent"></ng-container>
</a>
